const BASE_URL = 'https://dev.exdev.ir/v1/'
const SOCKET_URL = 'https://dev.exdev.ir/'
const HOME = process.env.REACT_APP_HOME

export { BASE_URL, SOCKET_URL, HOME }
 